var render = function render(){
  var _vm$releaseDetail, _vm$releaseDetail2, _vm$releaseDetail3, _vm$releaseDetail3$pl, _vm$releaseDetail4, _vm$releaseDetail4$pl, _vm$releaseDetail5, _vm$releaseDetail6, _vm$getAppInfo, _vm$getAppInfo$latest, _vm$getAppInfo2, _vm$getAppInfo2$lates, _vm$releaseDetail7, _vm$releaseDetail8, _vm$releaseDetail9, _vm$releaseDetail9$me, _vm$releaseDetail0, _vm$releaseDetail0$na, _vm$releaseDetail0$na2, _vm$releaseDetail1, _vm$releaseDetail1$na, _vm$releaseDetail1$na2, _vm$releaseDetail10, _vm$releaseDetail10$n, _vm$releaseDetail10$n2, _vm$releaseDetail11, _vm$releaseDetail11$n, _vm$releaseDetail11$n2, _vm$releaseDetail12, _vm$releaseDetail12$n, _vm$releaseDetail12$n2, _vm$releaseDetail13, _vm$releaseDetail13$n, _vm$releaseDetail13$n2, _vm$releaseDetail14, _vm$releaseDetail14$n, _vm$releaseDetail14$n2, _vm$releaseDetail15, _vm$releaseDetail15$n, _vm$releaseDetail15$n2, _vm$releaseDetail16, _vm$releaseDetail16$n, _vm$releaseDetail16$n2, _vm$releaseDetail17, _vm$releaseDetail17$n, _vm$releaseDetail17$n2, _vm$releaseDetail18, _vm$releaseDetail19, _vm$releaseDetail20, _vm$releaseDetail21, _vm$releaseDetail21$m, _vm$releaseDetail22, _vm$releaseDetail23, _vm$releaseDetail23$m, _vm$releaseDetail24, _vm$releaseDetail25, _vm$releaseDetail25$m, _vm$releaseDetail26, _vm$releaseDetail27, _vm$releaseDetail27$m, _vm$releaseDetail28, _vm$releaseDetail29, _vm$releaseDetail29$m, _vm$releaseDetail30, _vm$releaseDetail31, _vm$releaseDetail31$m, _vm$releaseDetail31$m2, _vm$releaseDetail32, _vm$releaseDetail33, _vm$releaseDetail33$m, _vm$releaseDetail33$m2, _vm$releaseDetail34, _vm$releaseDetail34$u, _vm$releaseDetail35, _vm$releaseDetail36, _vm$releaseDetail37, _vm$releaseDetail38, _vm$releaseDetail38$n, _vm$releaseDetail38$n2, _vm$releaseDetail39, _vm$releaseDetail39$n, _vm$releaseDetail39$n2, _vm$releaseDetail40, _vm$releaseDetail41, _vm$releaseDetail41$m, _vm$releaseDetail41$m2, _vm$releaseDetail42, _vm$releaseDetail42$m, _vm$releaseDetail43, _vm$releaseDetail44, _vm$releaseDetail44$m, _vm$releaseDetail44$m2, _vm$releaseDetail45, _vm$releaseDetail45$m, _vm$releaseDetail45$m2, _vm$releaseDetail46, _vm$releaseDetail46$m, _vm$releaseDetail47, _vm$releaseDetail48, _vm$releaseDetail49, _vm$releaseDetail49$m, _vm$releaseDetail50, _vm$releaseDetail51, _vm$releaseDetail51$m, _vm$releaseDetail52, _vm$releaseDetail53, _vm$releaseDetail53$m, _vm$releaseDetail53$m2, _vm$releaseDetail54, _vm$releaseDetail55, _vm$releaseDetail55$m, _vm$releaseDetail56;
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_vm.getReleaseDetailErrorMessage ? _c('v-row', [_c('v-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('no-data', {
    attrs: {
      "full-page-error": "",
      "first-text": _vm.getReleaseDetailErrorMessage
    }
  })], 1)], 1) : _c('v-row', [_c('v-col', {
    staticClass: "smallFont darkGrey--text",
    attrs: {
      "cols": "12"
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.getAppInfo.name) + " ")]), _vm._v("/ "), _c('span', {
    staticClass: "cursor-pointer info--text",
    on: {
      "click": function click($event) {
        return _vm.$router.push({
          name: 'app-release-index',
          params: {
            app_id: _vm.$route.params.app_id
          }
        });
      }
    }
  }, [_vm._v("Releases")]), _vm._v(" / "), _c('span', {
    staticClass: "info--text"
  }, [_vm._v(" " + _vm._s((_vm$releaseDetail = _vm.releaseDetail) === null || _vm$releaseDetail === void 0 ? void 0 : _vm$releaseDetail.id))]), _vm.$route.params.comment_id ? _c('span', {
    staticClass: "info--text cursor-pointer",
    on: {
      "click": function click($event) {
        return _vm.$router.push({
          name: 'release-comment-list'
        });
      }
    }
  }, [_vm._v(" / Comment / ")]) : _vm._e(), _vm.$route.params.comment_id ? _c('span', {
    staticClass: "info--text"
  }, [_vm._v(_vm._s(_vm.$route.params.comment_id))]) : _vm._e()]), _c('v-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('v-card', {
    staticClass: "pa-2",
    attrs: {
      "outlined": _vm.$vuetify.theme.dark,
      "flat": ""
    }
  }, [_vm.getAppInfoLoading ? _c('v-row', [_c('v-col', [_c('v-skeleton-loader', {
    attrs: {
      "type": "list"
    }
  })], 1), _c('v-col', [_c('v-skeleton-loader', {
    attrs: {
      "type": "button"
    }
  })], 1)], 1) : _c('v-row', [_c('v-col', {
    attrs: {
      "cols": "auto"
    }
  }, [_c('v-row', {
    attrs: {
      "align": "center"
    }
  }, [_c('v-col', {
    attrs: {
      "cols": "auto"
    }
  }, [_vm.releaseLoading ? _c('div', [_c('v-skeleton-loader', {
    attrs: {
      "type": "button"
    }
  })], 1) : _c('div', [_c('img', {
    attrs: {
      "src": ((_vm$releaseDetail2 = _vm.releaseDetail) === null || _vm$releaseDetail2 === void 0 ? void 0 : _vm$releaseDetail2.image) || "/media/defaults/".concat(_vm.$vuetify.theme.dark ? 'app_default_light' : 'app_default', ".svg"),
      "height": "50"
    },
    on: {
      "error": _vm.replaceDefaultReleaseImage
    }
  })])]), _c('v-col', [_vm.releaseLoading ? _c('div', [_c('v-skeleton-loader', {
    attrs: {
      "type": "button, list"
    }
  })], 1) : _c('div', [_c('div', [((_vm$releaseDetail3 = _vm.releaseDetail) === null || _vm$releaseDetail3 === void 0 ? void 0 : (_vm$releaseDetail3$pl = _vm$releaseDetail3.platform) === null || _vm$releaseDetail3$pl === void 0 ? void 0 : _vm$releaseDetail3$pl.toLowerCase()) === 'android' ? _c('v-icon', {
    staticClass: "mt-n2",
    attrs: {
      "color": "success",
      "size": "30"
    },
    domProps: {
      "textContent": _vm._s('mdi-android')
    }
  }) : _vm._e(), ((_vm$releaseDetail4 = _vm.releaseDetail) === null || _vm$releaseDetail4 === void 0 ? void 0 : (_vm$releaseDetail4$pl = _vm$releaseDetail4.platform) === null || _vm$releaseDetail4$pl === void 0 ? void 0 : _vm$releaseDetail4$pl.toLowerCase()) === 'ios' ? _c('v-icon', {
    staticClass: "mt-n2",
    attrs: {
      "size": "30"
    },
    domProps: {
      "textContent": _vm._s('mdi-apple')
    }
  }) : _vm._e(), _c('span', {
    staticClass: "titleFont ml-2"
  }, [_vm._v(_vm._s((_vm$releaseDetail5 = _vm.releaseDetail) === null || _vm$releaseDetail5 === void 0 ? void 0 : _vm$releaseDetail5.version) + " (" + _vm._s(((_vm$releaseDetail6 = _vm.releaseDetail) === null || _vm$releaseDetail6 === void 0 ? void 0 : _vm$releaseDetail6.version_code) || "") + ")")])], 1), [(_vm$getAppInfo = _vm.getAppInfo) === null || _vm$getAppInfo === void 0 ? void 0 : (_vm$getAppInfo$latest = _vm$getAppInfo.latest_releases) === null || _vm$getAppInfo$latest === void 0 ? void 0 : _vm$getAppInfo$latest.android, (_vm$getAppInfo2 = _vm.getAppInfo) === null || _vm$getAppInfo2 === void 0 ? void 0 : (_vm$getAppInfo2$lates = _vm$getAppInfo2.latest_releases) === null || _vm$getAppInfo2$lates === void 0 ? void 0 : _vm$getAppInfo2$lates.ios].includes(_vm.releaseDetail.id) ? _c('div', {
    staticClass: "smallFont info--text"
  }, [_vm._v(" Latest Release ")]) : _vm._e()])])], 1)], 1), _c('v-col', {
    staticClass: "text-right"
  }, [_vm.showArchive ? _c('v-btn', {
    attrs: {
      "disabled": _vm.releaseLoading,
      "icon": ""
    },
    on: {
      "click": function click($event) {
        _vm.archiveModal = true;
      }
    }
  }, [_c('v-tooltip', {
    attrs: {
      "bottom": ""
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function fn(_ref) {
        var on = _ref.on;
        return [_c('v-icon', _vm._g({
          attrs: {
            "color": "darkGrey"
          }
        }, on), [_vm._v(" mdi-archive-outline ")])];
      }
    }], null, false, 104637410)
  }, [_c('span', [_vm._v("Archive Release")])])], 1) : _vm._e(), _vm.canManageRelease && [2, 3].includes(_vm.releaseDetail.status) ? _c('v-tooltip', {
    attrs: {
      "bottom": ""
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function fn(_ref2) {
        var on = _ref2.on;
        return [_c('v-btn', _vm._g({
          attrs: {
            "disabled": _vm.releaseLoading,
            "icon": ""
          },
          on: {
            "click": function click($event) {
              _vm.deleteModal = true;
            }
          }
        }, on), [_c('v-icon', {
          attrs: {
            "color": "error"
          },
          domProps: {
            "textContent": _vm._s('mdi-delete')
          }
        })], 1)];
      }
    }], null, false, 3166978102)
  }, [_c('span', [_vm._v(" Delete Release ")])]) : _vm._e(), [1].includes(_vm.releaseDetail.status) ? _c('v-btn', {
    attrs: {
      "disabled": _vm.releaseLoading,
      "icon": ""
    },
    on: {
      "click": function click($event) {
        return _vm.onDownloadClick(_vm.releaseDetail);
      }
    }
  }, [_c('v-tooltip', {
    attrs: {
      "bottom": ""
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function fn(_ref3) {
        var on = _ref3.on;
        return [_c('v-icon', _vm._g({
          attrs: {
            "color": "darkGrey"
          }
        }, on), [_vm._v(" get_app ")])];
      }
    }], null, false, 323344616)
  }, [_c('span', [_vm._v("Download App File")])])], 1) : _vm._e(), _vm.canManageRelease ? [((_vm$releaseDetail7 = _vm.releaseDetail) === null || _vm$releaseDetail7 === void 0 ? void 0 : _vm$releaseDetail7.status) !== 1 ? _c('v-tooltip', {
    attrs: {
      "bottom": ""
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function fn(_ref4) {
        var on = _ref4.on;
        return [_c('span', _vm._g({}, on), [_c('v-btn', {
          attrs: {
            "disabled": "",
            "icon": ""
          }
        }, [_c('v-icon', [_vm._v("mdi-share-variant")])], 1)], 1)];
      }
    }], null, false, 3700681754)
  }, [_c('span', [_vm._v(" This release is not active ")])]) : ((_vm$releaseDetail8 = _vm.releaseDetail) === null || _vm$releaseDetail8 === void 0 ? void 0 : _vm$releaseDetail8.platform) === 'ios' && ((_vm$releaseDetail9 = _vm.releaseDetail) === null || _vm$releaseDetail9 === void 0 ? void 0 : (_vm$releaseDetail9$me = _vm$releaseDetail9.meta) === null || _vm$releaseDetail9$me === void 0 ? void 0 : _vm$releaseDetail9$me.signingType) !== 'enterprise' ? _c('v-tooltip', {
    attrs: {
      "bottom": ""
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function fn(_ref5) {
        var on = _ref5.on;
        return [_c('span', _vm._g({}, on), [_c('v-btn', {
          attrs: {
            "icon": ""
          },
          on: {
            "click": function click($event) {
              _vm.iosShareLearnMore = true;
            }
          }
        }, [_c('v-icon', [_vm._v("mdi-share-variant")])], 1)], 1)];
      }
    }], null, false, 3307183014)
  }, [_c('span', [_vm._v(" Public install links for iOS apps are exclusive to Enterprise builds. "), _c('br'), _vm._v(" Ad-hoc builds can be shared with unlimited and free guest testers. Click to learn more... ")])]) : _c('v-menu', {
    attrs: {
      "bottom": "",
      "nudge-bottom": "35"
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function fn(_ref6) {
        var on = _ref6.on;
        return [_c('v-btn', _vm._g({
          attrs: {
            "disabled": _vm.releaseLoading,
            "icon": ""
          }
        }, on), [_c('v-tooltip', {
          attrs: {
            "bottom": ""
          },
          scopedSlots: _vm._u([{
            key: "activator",
            fn: function fn(_ref7) {
              var on = _ref7.on;
              return [_c('v-icon', _vm._g({
                attrs: {
                  "color": "darkGrey"
                }
              }, on), [_vm._v(" mdi-share-variant ")])];
            }
          }], null, true)
        }, [_c('span', [_vm._v("Share Release")])])], 1)];
      }
    }], null, false, 1187573105)
  }, [_c('v-list', {
    attrs: {
      "dense": ""
    }
  }, [_c('v-list-item', {
    on: {
      "click": _vm.openInstall
    }
  }, [_c('v-icon', {
    attrs: {
      "left": ""
    },
    domProps: {
      "textContent": _vm._s('mdi-qrcode')
    }
  }), _vm._v(" Share Internally ")], 1), _c('v-list-item', {
    on: {
      "click": function click($event) {
        _vm.generateShareLinkModal = true;
      }
    }
  }, [_c('v-icon', {
    attrs: {
      "left": ""
    },
    domProps: {
      "textContent": _vm._s('mdi-share')
    }
  }), _vm._v(" Share Externally ")], 1)], 1)], 1)] : _vm._e(), _c('v-btn', {
    attrs: {
      "disabled": !((_vm$releaseDetail0 = _vm.releaseDetail) !== null && _vm$releaseDetail0 !== void 0 && (_vm$releaseDetail0$na = _vm$releaseDetail0.navigation) !== null && _vm$releaseDetail0$na !== void 0 && (_vm$releaseDetail0$na2 = _vm$releaseDetail0$na.previous) !== null && _vm$releaseDetail0$na2 !== void 0 && _vm$releaseDetail0$na2.id) || _vm.releaseLoading,
      "icon": ""
    },
    on: {
      "click": _vm.getPreviousRelease
    }
  }, [_c('v-tooltip', {
    attrs: {
      "bottom": ""
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function fn(_ref8) {
        var on = _ref8.on;
        return [_c('v-icon', _vm._g({
          attrs: {
            "size": "30",
            "color": "darkGrey"
          },
          domProps: {
            "textContent": _vm._s('mdi-chevron-left-box-outline')
          }
        }, on))];
      }
    }])
  }, [_c('v-icon', {
    attrs: {
      "left": "",
      "color": "darkGrey"
    },
    domProps: {
      "textContent": _vm._s(((_vm$releaseDetail1 = _vm.releaseDetail) === null || _vm$releaseDetail1 === void 0 ? void 0 : (_vm$releaseDetail1$na = _vm$releaseDetail1.navigation) === null || _vm$releaseDetail1$na === void 0 ? void 0 : (_vm$releaseDetail1$na2 = _vm$releaseDetail1$na.previous) === null || _vm$releaseDetail1$na2 === void 0 ? void 0 : _vm$releaseDetail1$na2.platform) === 'android' ? 'mdi-android' : 'mdi-apple')
    }
  }), (_vm$releaseDetail10 = _vm.releaseDetail) !== null && _vm$releaseDetail10 !== void 0 && (_vm$releaseDetail10$n = _vm$releaseDetail10.navigation) !== null && _vm$releaseDetail10$n !== void 0 && (_vm$releaseDetail10$n2 = _vm$releaseDetail10$n.previous) !== null && _vm$releaseDetail10$n2 !== void 0 && _vm$releaseDetail10$n2.version ? _c('span', [_vm._v(_vm._s(_vm.shortenVersion((_vm$releaseDetail11 = _vm.releaseDetail) === null || _vm$releaseDetail11 === void 0 ? void 0 : (_vm$releaseDetail11$n = _vm$releaseDetail11.navigation) === null || _vm$releaseDetail11$n === void 0 ? void 0 : (_vm$releaseDetail11$n2 = _vm$releaseDetail11$n.previous) === null || _vm$releaseDetail11$n2 === void 0 ? void 0 : _vm$releaseDetail11$n2.version)) + " (" + _vm._s(_vm.shortenVersion((_vm$releaseDetail12 = _vm.releaseDetail) === null || _vm$releaseDetail12 === void 0 ? void 0 : (_vm$releaseDetail12$n = _vm$releaseDetail12.navigation) === null || _vm$releaseDetail12$n === void 0 ? void 0 : (_vm$releaseDetail12$n2 = _vm$releaseDetail12$n.previous) === null || _vm$releaseDetail12$n2 === void 0 ? void 0 : _vm$releaseDetail12$n2.version_code)) + ")")]) : _vm._e()], 1)], 1), _c('v-btn', {
    attrs: {
      "disabled": !((_vm$releaseDetail13 = _vm.releaseDetail) !== null && _vm$releaseDetail13 !== void 0 && (_vm$releaseDetail13$n = _vm$releaseDetail13.navigation) !== null && _vm$releaseDetail13$n !== void 0 && (_vm$releaseDetail13$n2 = _vm$releaseDetail13$n.next) !== null && _vm$releaseDetail13$n2 !== void 0 && _vm$releaseDetail13$n2.id) || _vm.releaseLoading,
      "icon": ""
    },
    on: {
      "click": _vm.getNextRelease
    }
  }, [_c('v-tooltip', {
    attrs: {
      "bottom": ""
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function fn(_ref9) {
        var on = _ref9.on;
        return [_c('v-icon', _vm._g({
          attrs: {
            "size": "30"
          },
          domProps: {
            "textContent": _vm._s('mdi-chevron-right-box-outline')
          }
        }, on))];
      }
    }])
  }, [_c('v-icon', {
    attrs: {
      "left": "",
      "color": "darkGrey"
    },
    domProps: {
      "textContent": _vm._s(((_vm$releaseDetail14 = _vm.releaseDetail) === null || _vm$releaseDetail14 === void 0 ? void 0 : (_vm$releaseDetail14$n = _vm$releaseDetail14.navigation) === null || _vm$releaseDetail14$n === void 0 ? void 0 : (_vm$releaseDetail14$n2 = _vm$releaseDetail14$n.next) === null || _vm$releaseDetail14$n2 === void 0 ? void 0 : _vm$releaseDetail14$n2.platform) === 'android' ? 'mdi-android' : 'mdi-apple')
    }
  }), (_vm$releaseDetail15 = _vm.releaseDetail) !== null && _vm$releaseDetail15 !== void 0 && (_vm$releaseDetail15$n = _vm$releaseDetail15.navigation) !== null && _vm$releaseDetail15$n !== void 0 && (_vm$releaseDetail15$n2 = _vm$releaseDetail15$n.next) !== null && _vm$releaseDetail15$n2 !== void 0 && _vm$releaseDetail15$n2.version ? _c('span', [_vm._v(_vm._s(_vm.shortenVersion((_vm$releaseDetail16 = _vm.releaseDetail) === null || _vm$releaseDetail16 === void 0 ? void 0 : (_vm$releaseDetail16$n = _vm$releaseDetail16.navigation) === null || _vm$releaseDetail16$n === void 0 ? void 0 : (_vm$releaseDetail16$n2 = _vm$releaseDetail16$n.next) === null || _vm$releaseDetail16$n2 === void 0 ? void 0 : _vm$releaseDetail16$n2.version)) + " (" + _vm._s(_vm.shortenVersion((_vm$releaseDetail17 = _vm.releaseDetail) === null || _vm$releaseDetail17 === void 0 ? void 0 : (_vm$releaseDetail17$n = _vm$releaseDetail17.navigation) === null || _vm$releaseDetail17$n === void 0 ? void 0 : (_vm$releaseDetail17$n2 = _vm$releaseDetail17$n.next) === null || _vm$releaseDetail17$n2 === void 0 ? void 0 : _vm$releaseDetail17$n2.version_code)) + ")")]) : _vm._e()], 1)], 1)], 2)], 1)], 1)], 1), _vm.releaseLoading ? [_c('v-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('v-skeleton-loader', {
    attrs: {
      "type": "heading"
    }
  }), _c('v-skeleton-loader', {
    attrs: {
      "type": "divider"
    }
  }), _c('v-skeleton-loader', {
    attrs: {
      "type": "card, list-item-two-line\t"
    }
  })], 1)] : _vm._e(), !_vm.releaseLoading ? [_c('v-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('v-row', {
    staticClass: "mx-2 pb-2"
  }, [_c('v-tabs', {
    model: {
      value: _vm.selectedTab,
      callback: function callback($$v) {
        _vm.selectedTab = $$v;
      },
      expression: "selectedTab"
    }
  }, [_vm._l(_vm.releaseTabs, function (value, key) {
    return [_c('tab', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: value.permissions,
        expression: "value.permissions"
      }],
      key: key,
      attrs: {
        "label": value.title,
        "loading": _vm.releaseLoading
      },
      on: {
        "click": function click($event) {
          return _vm.navigate(value);
        }
      }
    })];
  })], 2)], 1)], 1), _vm.getReleaseDetailErrorMessage ? [_c('no-data', {
    attrs: {
      "first-text": _vm.getReleaseDetailErrorMessage
    }
  })] : [_vm.selectedTab === 0 ? _c('v-col', {
    attrs: {
      "cols": "12"
    }
  }, [_vm.releaseLoading ? _c('v-row', [_c('v-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('v-skeleton-loader', {
    attrs: {
      "type": "card,list"
    }
  })], 1), _c('v-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('v-skeleton-loader', {
    attrs: {
      "type": "card,table"
    }
  })], 1)], 1) : [_c('group-status-card', {
    attrs: {
      "outlined": "",
      "dot-type": "icon",
      "notify-loading": _vm.notifyLoading,
      "stats": _vm.stats.filter(function (stat) {
        return stat.permissions;
      })
    },
    on: {
      "update-notify": _vm.updateNotify
    }
  }), _c('v-card', {
    staticClass: "pa-4 mt-3",
    attrs: {
      "outlined": ""
    }
  }, [_c('v-row', [_c('v-col', {
    attrs: {
      "cols": "12",
      "md": "6"
    }
  }, [_c('div', {
    staticClass: "pa-2 lightBackground"
  }, [_vm._v("Information")]), _c('div', {
    staticClass: "smallFont pa-2 pb-0"
  }, [_c('span', [_vm._v("Release ID:")]), _c('span', {
    staticClass: "ml-3"
  }, [_vm._v(_vm._s((_vm$releaseDetail18 = _vm.releaseDetail) === null || _vm$releaseDetail18 === void 0 ? void 0 : _vm$releaseDetail18.id))])]), _c('div', {
    staticClass: "smallFont px-2"
  }, [_c('span', [_vm._v(_vm._s(((_vm$releaseDetail19 = _vm.releaseDetail) === null || _vm$releaseDetail19 === void 0 ? void 0 : _vm$releaseDetail19.platform) === "android" ? "Package" : "Bundle ID") + " :")]), _c('span', {
    staticClass: "ml-3"
  }, [_vm._v(_vm._s((_vm$releaseDetail20 = _vm.releaseDetail) === null || _vm$releaseDetail20 === void 0 ? void 0 : _vm$releaseDetail20.package))])]), _c('div', {
    staticClass: "smallFont px-2"
  }, [_c('span', [_vm._v("Signing:")]), _c('span', {
    staticClass: "ml-3"
  }, [_vm._v(_vm._s(((_vm$releaseDetail21 = _vm.releaseDetail) === null || _vm$releaseDetail21 === void 0 ? void 0 : (_vm$releaseDetail21$m = _vm$releaseDetail21.meta) === null || _vm$releaseDetail21$m === void 0 ? void 0 : _vm$releaseDetail21$m.signingType) || "-"))])]), ((_vm$releaseDetail22 = _vm.releaseDetail) === null || _vm$releaseDetail22 === void 0 ? void 0 : _vm$releaseDetail22.platform) === 'ios' ? _c('div', {
    staticClass: "smallFont px-2 pb-0"
  }, [_c('span', [_vm._v("Platform Version:")]), _c('span', {
    staticClass: "ml-3"
  }, [_vm._v(_vm._s((_vm$releaseDetail23 = _vm.releaseDetail) === null || _vm$releaseDetail23 === void 0 ? void 0 : (_vm$releaseDetail23$m = _vm$releaseDetail23.meta) === null || _vm$releaseDetail23$m === void 0 ? void 0 : _vm$releaseDetail23$m.platformVersion))])]) : _vm._e(), ((_vm$releaseDetail24 = _vm.releaseDetail) === null || _vm$releaseDetail24 === void 0 ? void 0 : _vm$releaseDetail24.platform) === 'ios' ? _c('div', {
    staticClass: "smallFont px-2 pb-0"
  }, [_c('span', [_vm._v("Minimum OS Version:")]), _c('span', {
    staticClass: "ml-3"
  }, [_vm._v(_vm._s((_vm$releaseDetail25 = _vm.releaseDetail) === null || _vm$releaseDetail25 === void 0 ? void 0 : (_vm$releaseDetail25$m = _vm$releaseDetail25.meta) === null || _vm$releaseDetail25$m === void 0 ? void 0 : _vm$releaseDetail25$m.minimumOSVersion))])]) : _vm._e(), ((_vm$releaseDetail26 = _vm.releaseDetail) === null || _vm$releaseDetail26 === void 0 ? void 0 : _vm$releaseDetail26.platform) === 'android' ? _c('div', {
    staticClass: "smallFont px-2 pb-0"
  }, [_c('span', [_vm._v("Minimum SDK Version:")]), _c('span', {
    staticClass: "ml-3"
  }, [_vm._v(_vm._s((_vm$releaseDetail27 = _vm.releaseDetail) === null || _vm$releaseDetail27 === void 0 ? void 0 : (_vm$releaseDetail27$m = _vm$releaseDetail27.meta) === null || _vm$releaseDetail27$m === void 0 ? void 0 : _vm$releaseDetail27$m.minSDKVersion))])]) : _vm._e(), ((_vm$releaseDetail28 = _vm.releaseDetail) === null || _vm$releaseDetail28 === void 0 ? void 0 : _vm$releaseDetail28.platform) === 'android' ? _c('div', {
    staticClass: "smallFont px-2 pb-0"
  }, [_c('span', [_vm._v("Target SDK Version:")]), _c('span', {
    staticClass: "ml-3"
  }, [_vm._v(_vm._s((_vm$releaseDetail29 = _vm.releaseDetail) === null || _vm$releaseDetail29 === void 0 ? void 0 : (_vm$releaseDetail29$m = _vm$releaseDetail29.meta) === null || _vm$releaseDetail29$m === void 0 ? void 0 : _vm$releaseDetail29$m.targetSDKVersion))])]) : _vm._e(), ((_vm$releaseDetail30 = _vm.releaseDetail) === null || _vm$releaseDetail30 === void 0 ? void 0 : _vm$releaseDetail30.platform) === 'ios' ? _c('div', {
    staticClass: "smallFont px-2 pb-0"
  }, [_c('span', [_vm._v("Supported Platforms:")]), _c('span', {
    staticClass: "ml-3"
  }, [_vm._v(_vm._s(((_vm$releaseDetail31 = _vm.releaseDetail) === null || _vm$releaseDetail31 === void 0 ? void 0 : (_vm$releaseDetail31$m = _vm$releaseDetail31.meta) === null || _vm$releaseDetail31$m === void 0 ? void 0 : (_vm$releaseDetail31$m2 = _vm$releaseDetail31$m.supportedPlatforms) === null || _vm$releaseDetail31$m2 === void 0 ? void 0 : _vm$releaseDetail31$m2.join(", ")) || "-"))])]) : _vm._e(), ((_vm$releaseDetail32 = _vm.releaseDetail) === null || _vm$releaseDetail32 === void 0 ? void 0 : _vm$releaseDetail32.platform) === 'ios' ? _c('div', {
    staticClass: "smallFont px-2 pb-0"
  }, [_c('span', [_vm._v("Platforms:")]), _c('span', {
    staticClass: "ml-3"
  }, [_vm._v(_vm._s(((_vm$releaseDetail33 = _vm.releaseDetail) === null || _vm$releaseDetail33 === void 0 ? void 0 : (_vm$releaseDetail33$m = _vm$releaseDetail33.meta) === null || _vm$releaseDetail33$m === void 0 ? void 0 : (_vm$releaseDetail33$m2 = _vm$releaseDetail33$m.platforms) === null || _vm$releaseDetail33$m2 === void 0 ? void 0 : _vm$releaseDetail33$m2.join(", ")) || "-"))])]) : _vm._e(), _c('div', {
    staticClass: "smallFont px-2 mt-4"
  }, [_c('span', [_vm._v("Developer:")]), _c('span', {
    staticClass: "ml-3"
  }, [_vm._v(_vm._s((_vm$releaseDetail34 = _vm.releaseDetail) === null || _vm$releaseDetail34 === void 0 ? void 0 : (_vm$releaseDetail34$u = _vm$releaseDetail34.user) === null || _vm$releaseDetail34$u === void 0 ? void 0 : _vm$releaseDetail34$u.name))])]), (_vm$releaseDetail35 = _vm.releaseDetail) !== null && _vm$releaseDetail35 !== void 0 && _vm$releaseDetail35.archive_reason ? _c('div', {
    staticClass: "smallFont px-2"
  }, [_c('span', [_vm._v("Archive reason:")]), _c('span', {
    staticClass: "ml-3"
  }, [_vm._v(_vm._s((_vm$releaseDetail36 = _vm.releaseDetail) === null || _vm$releaseDetail36 === void 0 ? void 0 : _vm$releaseDetail36.archive_reason))])]) : _vm._e(), _c('div', {
    staticClass: "smallFont px-2 pb-0 mt-4"
  }, [_c('span', [_vm._v("Source:")]), _c('span', {
    staticClass: "ml-3"
  }, [_vm._v(" " + _vm._s(_vm.releaseSourceDetail.name || "-") + " "), _c('v-tooltip', {
    attrs: {
      "bottom": ""
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function fn(_ref0) {
        var on = _ref0.on;
        return [_c('v-icon', _vm._g({
          attrs: {
            "size": "20"
          },
          domProps: {
            "textContent": _vm._s('mdi-information-outline')
          }
        }, on))];
      }
    }], null, false, 210534074)
  }, [_c('div', [_c('div', [_vm._v("Uploaded from")]), _c('ul', [_c('li', [_vm._v(" Source: " + _vm._s(_vm.releaseSourceDetail.name || "-") + " ")]), _c('li', [_vm._v(" Version: " + _vm._s(_vm.releaseSourceDetail.version || "-") + " ")]), _c('li', [_vm._v(" Source version: " + _vm._s(_vm.releaseSourceDetail.source_versions || "-") + " ")]), _c('li', [_vm._v(" Git release notes: "), _c('v-icon', {
    attrs: {
      "color": _vm.releaseSourceDetail.git_release_notes ? 'success' : 'error'
    },
    domProps: {
      "textContent": _vm._s(_vm.releaseSourceDetail.git_release_notes ? 'mdi-check' : 'mdi-close')
    }
  })], 1)])])])], 1)])]), _c('v-col', {
    attrs: {
      "cols": "12",
      "md": "6"
    }
  }, [_c('div', {
    staticClass: "pa-2 lightBackground"
  }, [_vm._v(" Release notes "), _vm.canManageRelease ? _c('span', {
    staticClass: "float-right cursor-pointer"
  }, [_c('v-icon', {
    domProps: {
      "textContent": _vm._s('mdi-pencil')
    },
    on: {
      "click": _vm.onEditClick
    }
  })], 1) : _vm._e()]), _c('div', {
    staticClass: "smallFont pa-2 pb-0"
  }, [_vm.releaseDetail.note ? _c('div', {
    staticClass: "text-pre-wrap"
  }, [_vm.readMoreNote ? _c('span', [_vm._v(" " + _vm._s((_vm$releaseDetail37 = _vm.releaseDetail) === null || _vm$releaseDetail37 === void 0 ? void 0 : _vm$releaseDetail37.note.trim()) + " ")]) : _c('span', [_vm._v(" " + _vm._s((_vm$releaseDetail38 = _vm.releaseDetail) === null || _vm$releaseDetail38 === void 0 ? void 0 : (_vm$releaseDetail38$n = _vm$releaseDetail38.note) === null || _vm$releaseDetail38$n === void 0 ? void 0 : (_vm$releaseDetail38$n2 = _vm$releaseDetail38$n.trim()) === null || _vm$releaseDetail38$n2 === void 0 ? void 0 : _vm$releaseDetail38$n2.slice(0, 600)) + " ")]), ((_vm$releaseDetail39 = _vm.releaseDetail) === null || _vm$releaseDetail39 === void 0 ? void 0 : (_vm$releaseDetail39$n = _vm$releaseDetail39.note) === null || _vm$releaseDetail39$n === void 0 ? void 0 : (_vm$releaseDetail39$n2 = _vm$releaseDetail39$n.trim()) === null || _vm$releaseDetail39$n2 === void 0 ? void 0 : _vm$releaseDetail39$n2.length) > 600 ? _c('span', {
    staticClass: "primary--text cursor-pointer",
    on: {
      "click": function click($event) {
        _vm.readMoreNote = !_vm.readMoreNote;
      }
    }
  }, [_vm._v(" " + _vm._s(_vm.readMoreNote ? "Read less..." : "Read more...") + " ")]) : _vm._e()]) : _c('span', [_vm._v(" - ")])])]), ((_vm$releaseDetail40 = _vm.releaseDetail) === null || _vm$releaseDetail40 === void 0 ? void 0 : _vm$releaseDetail40.platform) === 'android' ? _c('v-col', {
    staticClass: "cursor-pointer",
    attrs: {
      "cols": "6"
    },
    on: {
      "click": function click($event) {
        _vm.showPermissions = !_vm.showPermissions;
      }
    }
  }, [_c('div', {
    staticClass: "pa-2 lightBackground"
  }, [_vm._v(" Permissions "), _vm.canManageRelease ? _c('span', {
    staticClass: "float-right cursor-pointer"
  }, [_c('v-icon', {
    domProps: {
      "textContent": _vm._s(!_vm.showPermissions ? 'mdi-chevron-down' : 'mdi-chevron-up')
    }
  })], 1) : _vm._e()]), _vm.showPermissions ? _c('div', {
    staticClass: "mt-4"
  }, [(_vm$releaseDetail41 = _vm.releaseDetail) !== null && _vm$releaseDetail41 !== void 0 && (_vm$releaseDetail41$m = _vm$releaseDetail41.meta) !== null && _vm$releaseDetail41$m !== void 0 && (_vm$releaseDetail41$m2 = _vm$releaseDetail41$m.usesPermissions) !== null && _vm$releaseDetail41$m2 !== void 0 && _vm$releaseDetail41$m2.length ? _c('v-expand-transition', [_c('permission-mapper', {
    attrs: {
      "from-release-page": "",
      "permissions": ((_vm$releaseDetail42 = _vm.releaseDetail) === null || _vm$releaseDetail42 === void 0 ? void 0 : (_vm$releaseDetail42$m = _vm$releaseDetail42.meta) === null || _vm$releaseDetail42$m === void 0 ? void 0 : _vm$releaseDetail42$m.usesPermissions) || []
    }
  })], 1) : _c('div', {
    staticClass: "ml-2"
  }, [_vm._v("No permissions found")])], 1) : _vm._e()]) : _vm._e(), ((_vm$releaseDetail43 = _vm.releaseDetail) === null || _vm$releaseDetail43 === void 0 ? void 0 : _vm$releaseDetail43.platform) === 'ios' ? _c('v-col', {
    attrs: {
      "cols": "6"
    }
  }, [_c('div', {
    staticClass: "pa-2 lightBackground"
  }, [_c('span', {
    staticClass: "cursor-pointer",
    on: {
      "click": function click($event) {
        _vm.showUDID = !_vm.showUDID;
      }
    }
  }, [_vm._v(" Provisioned Devices (" + _vm._s(((_vm$releaseDetail44 = _vm.releaseDetail) === null || _vm$releaseDetail44 === void 0 ? void 0 : (_vm$releaseDetail44$m = _vm$releaseDetail44.meta) === null || _vm$releaseDetail44$m === void 0 ? void 0 : (_vm$releaseDetail44$m2 = _vm$releaseDetail44$m.provisionedDevices) === null || _vm$releaseDetail44$m2 === void 0 ? void 0 : _vm$releaseDetail44$m2.length) || "0") + " / 100) ")]), _c('span', {
    staticClass: "float-right cursor-pointer",
    on: {
      "click": function click($event) {
        _vm.showUDID = !_vm.showUDID;
      }
    }
  }, [_c('v-icon', {
    domProps: {
      "textContent": _vm._s(!_vm.showUDID ? 'mdi-chevron-down' : 'mdi-chevron-up')
    }
  })], 1)]), _c('v-expand-transition', [_vm.showUDID ? _c('div', {
    staticClass: "mt-4"
  }, [(_vm$releaseDetail45 = _vm.releaseDetail) !== null && _vm$releaseDetail45 !== void 0 && (_vm$releaseDetail45$m = _vm$releaseDetail45.meta) !== null && _vm$releaseDetail45$m !== void 0 && (_vm$releaseDetail45$m2 = _vm$releaseDetail45$m.provisionedDevices) !== null && _vm$releaseDetail45$m2 !== void 0 && _vm$releaseDetail45$m2.length ? _c('div', _vm._l((_vm$releaseDetail46 = _vm.releaseDetail) === null || _vm$releaseDetail46 === void 0 ? void 0 : (_vm$releaseDetail46$m = _vm$releaseDetail46.meta) === null || _vm$releaseDetail46$m === void 0 ? void 0 : _vm$releaseDetail46$m.provisionedDevices, function (udid, uindex) {
    return _c('div', {
      key: uindex,
      staticClass: "mb-1"
    }, [_c('span', {
      staticClass: "mr-2"
    }, [_vm._v(" " + _vm._s(uindex + 1) + ". ")]), _c('span', [_vm._v(" " + _vm._s(udid) + " ")])]);
  }), 0) : _c('div', {
    staticClass: "ml-2"
  }, [_vm._v("No devices found")])]) : _vm._e()])], 1) : _vm._e(), ((_vm$releaseDetail47 = _vm.releaseDetail) === null || _vm$releaseDetail47 === void 0 ? void 0 : _vm$releaseDetail47.platform) === 'ios' ? _c('v-col', {
    attrs: {
      "cols": "6"
    }
  }, [_c('div', {
    staticClass: "pa-2 lightBackground"
  }, [_vm._v("Certificate")]), ((_vm$releaseDetail48 = _vm.releaseDetail) === null || _vm$releaseDetail48 === void 0 ? void 0 : _vm$releaseDetail48.platform) === 'ios' ? _c('div', {
    staticClass: "smallFont px-2 pb-0"
  }, [_c('span', [_vm._v("Created:")]), _c('span', {
    staticClass: "ml-3"
  }, [_c('date-tooltip', {
    attrs: {
      "date": (_vm$releaseDetail49 = _vm.releaseDetail) === null || _vm$releaseDetail49 === void 0 ? void 0 : (_vm$releaseDetail49$m = _vm$releaseDetail49.meta) === null || _vm$releaseDetail49$m === void 0 ? void 0 : _vm$releaseDetail49$m.creationDate
    }
  })], 1)]) : _vm._e(), ((_vm$releaseDetail50 = _vm.releaseDetail) === null || _vm$releaseDetail50 === void 0 ? void 0 : _vm$releaseDetail50.platform) === 'ios' ? _c('div', {
    staticClass: "smallFont px-2 pb-0"
  }, [_c('span', [_vm._v("Expire:")]), _c('span', {
    staticClass: "ml-3"
  }, [_c('date-tooltip', {
    attrs: {
      "date": (_vm$releaseDetail51 = _vm.releaseDetail) === null || _vm$releaseDetail51 === void 0 ? void 0 : (_vm$releaseDetail51$m = _vm$releaseDetail51.meta) === null || _vm$releaseDetail51$m === void 0 ? void 0 : _vm$releaseDetail51$m.expirationDate
    }
  })], 1)]) : _vm._e(), ((_vm$releaseDetail52 = _vm.releaseDetail) === null || _vm$releaseDetail52 === void 0 ? void 0 : _vm$releaseDetail52.platform) === 'ios' ? _c('div', {
    staticClass: "smallFont px-2 pb-0"
  }, [_c('span', [_vm._v("Team Identifier:")]), _c('span', {
    staticClass: "ml-3"
  }, [_vm._v(" " + _vm._s(((_vm$releaseDetail53 = _vm.releaseDetail) === null || _vm$releaseDetail53 === void 0 ? void 0 : (_vm$releaseDetail53$m = _vm$releaseDetail53.meta) === null || _vm$releaseDetail53$m === void 0 ? void 0 : (_vm$releaseDetail53$m2 = _vm$releaseDetail53$m.teamIdentifier) === null || _vm$releaseDetail53$m2 === void 0 ? void 0 : _vm$releaseDetail53$m2.join(", ")) || "-") + " ")])]) : _vm._e(), ((_vm$releaseDetail54 = _vm.releaseDetail) === null || _vm$releaseDetail54 === void 0 ? void 0 : _vm$releaseDetail54.platform) === 'ios' ? _c('div', {
    staticClass: "smallFont px-2 pb-0"
  }, [_c('span', [_vm._v("Provisioning profile name:")]), _c('span', {
    staticClass: "ml-3"
  }, [_vm._v(" " + _vm._s((_vm$releaseDetail55 = _vm.releaseDetail) === null || _vm$releaseDetail55 === void 0 ? void 0 : (_vm$releaseDetail55$m = _vm$releaseDetail55.meta) === null || _vm$releaseDetail55$m === void 0 ? void 0 : _vm$releaseDetail55$m.provisioningProfileName) + " ")])]) : _vm._e()]) : _vm._e()], 1)], 1)]], 2) : _vm._e(), _vm.selectedTab === 1 ? _c('v-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('commentdetail', {
    key: _vm.releaseDetail.id,
    attrs: {
      "release": _vm.releaseDetail
    }
  })], 1) : _vm._e(), _vm.selectedTab === 2 ? _c('v-col', [_c('install-list', {
    key: _vm.releaseDetail.id,
    attrs: {
      "from-release-page": "",
      "release-id": (_vm$releaseDetail56 = _vm.releaseDetail) === null || _vm$releaseDetail56 === void 0 ? void 0 : _vm$releaseDetail56.id
    }
  })], 1) : _vm._e()]] : _vm._e()], 2), _c('Modal', {
    attrs: {
      "closeable": ""
    },
    scopedSlots: _vm._u([{
      key: "card",
      fn: function fn() {
        return [_c('ios-share-info')];
      },
      proxy: true
    }]),
    model: {
      value: _vm.iosShareLearnMore,
      callback: function callback($$v) {
        _vm.iosShareLearnMore = $$v;
      },
      expression: "iosShareLearnMore"
    }
  }), _c('Modal', {
    attrs: {
      "closeable": "",
      "hide-close": ""
    },
    scopedSlots: _vm._u([{
      key: "message",
      fn: function fn() {
        var _vm$getAppInfo$stats, _vm$getAppInfo$stats$;
        return [_c('v-row', {
          attrs: {
            "justify": "center"
          }
        }, [_c('v-col', {
          attrs: {
            "cols": "12"
          }
        }, [_c('h1', [_vm._v("Internal Share")])])], 1), _c('v-row', {
          attrs: {
            "justify": "center"
          }
        }, [_c('v-col', {
          staticClass: "font-16",
          attrs: {
            "cols": "12"
          }
        }, [_c('p', [_c('b', [_vm._v("Share Securely Within Your Team")]), _c('br'), _c('br'), _vm._v(" This release is exclusive to your team members with app access. Manage your team’s access in the "), _c('span', {
          staticClass: "primary--text cursor-pointer",
          on: {
            "click": function click($event) {
              return _vm.$router.push("/app/".concat(_vm.$route.params.app_id, "/settings/releases"));
            }
          }
        }, [_vm._v("App Settings")]), _vm._v(". ")]), _c('br'), _c('p', [_c('b', [_vm._v("Members ready to test:")]), _vm._v(" " + _vm._s(((_vm$getAppInfo$stats = _vm.getAppInfo.stats) === null || _vm$getAppInfo$stats === void 0 ? void 0 : (_vm$getAppInfo$stats$ = _vm$getAppInfo$stats.members) === null || _vm$getAppInfo$stats$ === void 0 ? void 0 : _vm$getAppInfo$stats$.active) || 1) + " ")])])], 1), _c('v-row', {
          attrs: {
            "justify": "center"
          }
        }, [_c('v-col', {
          staticClass: "font-16 font-weight-bold",
          attrs: {
            "cols": "12"
          }
        }, [_vm._v(" Instant Access with QR Code ")]), _c('v-col', {
          attrs: {
            "cols": "12"
          }
        }, [_c('qrcode', {
          attrs: {
            "options": {
              errorCorrectionLevel: 'Q',
              width: 200
            },
            "value": _vm.installLink
          }
        })], 1), _c('v-col', {
          staticClass: "text-center bodyFont",
          attrs: {
            "cols": "12"
          }
        }, [_vm._v(" Scan this QR code from your phone to open it in TestApp.io app ")]), _c('v-col', {
          staticClass: "bodyFont",
          attrs: {
            "cols": "12"
          }
        }, [_c('ul', [_c('li', [_vm._v(" Install our "), _c('a', {
          attrs: {
            "href": "https://play.google.com/store/apps/details?id=testapp.io&hl=en_US&gl=US",
            "target": "_blank"
          }
        }, [_vm._v("Android App")])]), _c('li', [_vm._v(" Install our "), _c('a', {
          attrs: {
            "href": "https://apps.apple.com/us/app/testapp-io/id1518972541",
            "target": "_blank"
          }
        }, [_vm._v("iOS App")])])])])], 1)];
      },
      proxy: true
    }]),
    model: {
      value: _vm.installModal,
      callback: function callback($$v) {
        _vm.installModal = $$v;
      },
      expression: "installModal"
    }
  }), _c('Modal', {
    attrs: {
      "fullscreen": _vm.$vuetify.breakpoint.mdAndDown,
      "width": _vm.$vuetify.breakpoint.mdAndUp ? '850' : ''
    },
    on: {
      "close": function close($event) {
        _vm.generateShareLinkModal = false;
      }
    },
    scopedSlots: _vm._u([{
      key: "card",
      fn: function fn() {
        return [_c('v-card', [_c('v-card-title', [_c('v-spacer'), _c('v-btn', {
          attrs: {
            "icon": ""
          },
          on: {
            "click": function click($event) {
              _vm.generateShareLinkModal = false;
            }
          }
        }, [_c('v-icon', [_vm._v("close")])], 1)], 1), _c('v-card-text', {
          staticClass: "pa-0"
        }, [_vm.generateShareLinkModal ? _c('share-link-stepper', {
          key: _vm.generateShareLinkModal,
          attrs: {
            "release-detail": _vm.releaseDetail
          },
          on: {
            "close": function close($event) {
              _vm.generateShareLinkModal = false;
            },
            "refresh": _vm.afterSuccess
          }
        }) : _vm._e()], 1)], 1)];
      },
      proxy: true
    }]),
    model: {
      value: _vm.generateShareLinkModal,
      callback: function callback($$v) {
        _vm.generateShareLinkModal = $$v;
      },
      expression: "generateShareLinkModal"
    }
  }), _c('Modal', {
    on: {
      "close": function close($event) {
        _vm.openShareLinkModal = false;
      }
    },
    scopedSlots: _vm._u([{
      key: "message",
      fn: function fn() {
        return [_c('share-link-modal', {
          attrs: {
            "from-release-page": "",
            "share-id": _vm.shareId
          }
        })];
      },
      proxy: true
    }]),
    model: {
      value: _vm.openShareLinkModal,
      callback: function callback($$v) {
        _vm.openShareLinkModal = $$v;
      },
      expression: "openShareLinkModal"
    }
  }), _c('Modal', {
    on: {
      "close": function close($event) {
        _vm.viewEditRelease = false;
      }
    },
    scopedSlots: _vm._u([{
      key: "message",
      fn: function fn() {
        return [_vm.viewEditRelease ? _c('UpdateReleasePanel', {
          attrs: {
            "app_id": _vm.getAppInfo.id,
            "release": _vm.releaseDetail
          },
          on: {
            "success": _vm.setReleaseNote
          }
        }) : _vm._e()];
      },
      proxy: true
    }]),
    model: {
      value: _vm.viewEditRelease,
      callback: function callback($$v) {
        _vm.viewEditRelease = $$v;
      },
      expression: "viewEditRelease"
    }
  }), _c('Modal', {
    scopedSlots: _vm._u([_vm.deleteModal ? {
      key: "card",
      fn: function fn() {
        return [_c('v-card', [_c('v-card-title', {
          staticClass: "font-weight-bold"
        }, [_vm._v("Delete release ")]), _c('v-divider'), _c('v-card-text', {
          staticClass: "my-4 message"
        }, [_c('p', [_vm._v("Are you sure you want to delete this release.")]), _c('v-alert', {
          staticClass: "mt-3",
          attrs: {
            "border": "left",
            "color": "info",
            "icon": "info",
            "outlined": ""
          }
        }, [_vm._v(" Archived releases are not available for installation and are not counted towards your storage quota. "), _c('br'), _c('br'), _vm._v(" They are there for your future reference. ")]), _c('v-alert', {
          staticClass: "mt-3",
          attrs: {
            "border": "left",
            "color": "error",
            "icon": "error",
            "outlined": ""
          }
        }, [_vm._v(" Deleted releases will be removed from: "), _c('br'), _c('br'), _c('ul', [_c('li', [_vm._v("Releases page")]), _c('li', [_vm._v("Installs page")]), _c('li', [_vm._v("Share page")]), _c('li', [_vm._v("Total releases stats (app and team)")])])])], 1), _c('v-divider'), _c('v-card-actions', {
          staticClass: "py-3"
        }, [_c('div', [_vm._v("No undo for this action")]), _c('v-spacer'), _c('v-btn', {
          staticClass: "text-transform-none",
          attrs: {
            "color": "primary",
            "text": "",
            "disabled": _vm.busy
          },
          on: {
            "click": function click($event) {
              _vm.deleteModal = false;
            }
          }
        }, [_vm._v("No ")]), _c('v-btn', {
          staticClass: "text-transform-none",
          attrs: {
            "loading": _vm.busy,
            "outlined": _vm.$vuetify.theme.dark,
            "color": "primary"
          },
          on: {
            "click": _vm.onConfirmDelete
          }
        }, [_vm._v("Yes ")])], 1)], 1)];
      },
      proxy: true
    } : null], null, true),
    model: {
      value: _vm.deleteModal,
      callback: function callback($$v) {
        _vm.deleteModal = $$v;
      },
      expression: "deleteModal"
    }
  }), _c('Modal', {
    attrs: {
      "warning": ""
    },
    scopedSlots: _vm._u([{
      key: "card",
      fn: function fn() {
        var _vm$getTeamPlanUsage, _vm$getTeamPlanUsage2;
        return [_vm.archiveModal ? [_c('v-card', {
          staticClass: "my-n3"
        }, [_c('v-card-title', [_c('div', {
          staticClass: "darkGrey--text bold-text"
        }, [_vm._v("Archive release")])]), _c('v-divider'), _c('v-card-text', {
          staticClass: "mt-4 message"
        }, [_vm._v(" Are you sure you want to archive " + _vm._s(_vm.selectedItem && !_vm.selectedItem.length ? "this release?" : "these selected releases?") + " "), _c('v-alert', {
          staticClass: "mt-3",
          attrs: {
            "border": "left",
            "color": "info",
            "icon": "info",
            "outlined": ""
          }
        }, [_vm._v(" By archiving releases, we will be deleting the (.aab / .apk / .ipa) "), _c('br'), _c('br'), _vm.archiveReadmore ? _c('div', [_vm._v(" Those releases will not be visible or available for installation in our app and public install links."), _c('br'), _c('br'), _vm._v(" Keeping all the data attached to these releases such as notes, installs, feedback,... for your future reference. ")]) : _vm._e(), !_vm.archiveReadmore ? _c('b', {
          staticClass: "pointer",
          on: {
            "click": function click($event) {
              _vm.archiveReadmore = !_vm.archiveReadmore;
            }
          }
        }, [_vm._v(" " + _vm._s("Read more...") + " ")]) : _vm._e()]), _c('v-alert', {
          staticClass: "mt-3",
          attrs: {
            "border": "left",
            "color": "success",
            "icon": "info",
            "outlined": ""
          }
        }, [_vm._v(" Archived releases will not be counted towards your team's storage quota 👍 ")])], 1), _c('v-divider'), _c('v-card-text', {
          staticClass: "pt-3"
        }, [_c('v-row', {
          attrs: {
            "align": "center"
          }
        }, [_c('v-col', {
          staticClass: "py-2",
          attrs: {
            "cols": !((_vm$getTeamPlanUsage = _vm.getTeamPlanUsage) !== null && _vm$getTeamPlanUsage !== void 0 && _vm$getTeamPlanUsage.auto_archive_release) ? 10 : 12
          }
        }, [_c('v-row', [_c('v-col', {
          attrs: {
            "cols": "12"
          }
        }, [_c('v-checkbox', {
          attrs: {
            "disabled": !((_vm$getTeamPlanUsage2 = _vm.getTeamPlanUsage) !== null && _vm$getTeamPlanUsage2 !== void 0 && _vm$getTeamPlanUsage2.auto_archive_release),
            "value": 0,
            "hide-details": "",
            "label": "Now"
          },
          model: {
            value: _vm.noValue,
            callback: function callback($$v) {
              _vm.noValue = $$v;
            },
            expression: "noValue"
          }
        })], 1), _c('v-col', {
          attrs: {
            "cols": "12"
          }
        }, [_c('v-row', {
          attrs: {
            "align": "center"
          }
        }, [_c('v-col', [_c('v-text-field', {
          attrs: {
            "disabled": _vm.noValue || !_vm.getTeamPlanUsage.auto_archive_release,
            "filled": "",
            "hide-details": "",
            "type": "number"
          },
          model: {
            value: _vm.selectedDay,
            callback: function callback($$v) {
              _vm.selectedDay = $$v;
            },
            expression: "selectedDay"
          }
        })], 1), _c('v-col', [_c('v-select', {
          attrs: {
            "disabled": _vm.noValue || !_vm.getTeamPlanUsage.auto_archive_release,
            "items": ['Days', 'Months'],
            "filled": "",
            "hide-details": ""
          },
          model: {
            value: _vm.selectedTime,
            callback: function callback($$v) {
              _vm.selectedTime = $$v;
            },
            expression: "selectedTime"
          }
        })], 1), !_vm.getTeamPlanUsage.auto_archive_release ? _c('v-col', {
          attrs: {
            "cols": "auto"
          }
        }, [_c('v-tooltip', {
          attrs: {
            "bottom": ""
          },
          scopedSlots: _vm._u([{
            key: "activator",
            fn: function fn(_ref1) {
              var on = _ref1.on;
              return [_c('span', _vm._g({}, on), [_c('v-btn', {
                attrs: {
                  "icon": ""
                },
                on: {
                  "click": function click($event) {
                    _vm.showStartTrialModal = true;
                  }
                }
              }, [_c('v-icon', {
                staticClass: "cursor-pointer",
                attrs: {
                  "color": "primary"
                },
                domProps: {
                  "textContent": _vm._s('mdi-lock-outline')
                }
              })], 1)], 1)];
            }
          }], null, false, 3046267260)
        }, [_c('span', [_vm._v("Auto archive settings is available for Starter & Pro team plans")])])], 1) : _vm._e(), _c('v-col', {
          staticClass: "py-0",
          attrs: {
            "cols": "12"
          }
        }, [_vm._v(" Note: Maximum 90 days or 3 months ")])], 1)], 1)], 1)], 1), _c('v-col', {
          attrs: {
            "cols": "12"
          }
        }, [_c('div', [_vm._v(" You can change this setting for future releases from the "), _c('span', {
          staticClass: "primary--text cursor-pointer",
          on: {
            "click": function click($event) {
              return _vm.$router.push("/app/".concat(_vm.$route.params.app_id, "/settings/releases"));
            }
          }
        }, [_vm._v("app settings")]), _vm._v(" page ")])])], 1)], 1), _c('v-divider'), _c('v-card-actions', {
          staticClass: "py-3"
        }, [_c('v-spacer'), _c('v-btn', {
          staticClass: "mr-2 text-transform-none",
          attrs: {
            "color": "primary",
            "text": "",
            "disabled": _vm.busy
          },
          on: {
            "click": function click($event) {
              _vm.archiveModal = false;
            }
          }
        }, [_vm._v("No ")]), _c('v-btn', {
          staticClass: "text-transform-none",
          attrs: {
            "loading": _vm.busy,
            "outlined": _vm.$vuetify.theme.dark,
            "color": "primary"
          },
          on: {
            "click": _vm.onConfirmArchive
          }
        }, [_vm._v("Yes ")])], 1)], 1)] : _vm._e()];
      },
      proxy: true
    }]),
    model: {
      value: _vm.archiveModal,
      callback: function callback($$v) {
        _vm.archiveModal = $$v;
      },
      expression: "archiveModal"
    }
  }), _c('Modal', {
    attrs: {
      "fullscreen": _vm.$vuetify.breakpoint.smAndDown,
      "width": "700"
    },
    scopedSlots: _vm._u([{
      key: "card",
      fn: function fn() {
        return [_vm.showHelpModal ? _c('demo-card', {
          attrs: {
            "event-type": _vm.eventName,
            "show-checkbox": _vm.showCheckbox,
            "document-link": "https://help.testapp.io/faq/how-to-add-udid-to-apple-developer-account/#how-to-register-udid-with-a-developer-account",
            "event-name": "Download UDIDs",
            "i-frame-link": "https://demo.arcade.software/w5ddiLruSIZFuJf1mtee?embed",
            "sub-title": "UDIDs are essential for distributing iOS apps to specific devices for testing.",
            "title": "Downloading iOS UDIDs"
          },
          on: {
            "close": function close($event) {
              _vm.showHelpModal = false;
            }
          }
        }) : _vm._e()];
      },
      proxy: true
    }]),
    model: {
      value: _vm.showHelpModal,
      callback: function callback($$v) {
        _vm.showHelpModal = $$v;
      },
      expression: "showHelpModal"
    }
  })], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }